import React, { useContext, useEffect, useState } from 'react';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import AppContext from '../Context/AppContext';
import WidgetUrlSite from '../componentsWidgets/WidgetUrlSite';
import UrlSiteManager from '../components/UrlSiteManager';
import WidgetPwaNotif from '../componentsWidgets/WidgetPwaNotif';
import WidgetNotifPrefs from '../componentsWidgets/WidgetNotifPrefs';

const Parametre = () => {
    const { setCurrentPage } = useContext(AppContext)
    const [openUrl, setOpenUrl] = useState(false)

    useEffect(() => {
        setCurrentPage('parametre')
    }, [])

    return (
        <MainLayout>
            <CenterLayout>
                <p className='fb cw fs20 mb2'>Paramettre</p>

                <div className='df fdc gap2' style={{ maxWidth: "560px" }}>
                    <WidgetPwaNotif />
                    <WidgetNotifPrefs />

                    <div className='df fdc gap1'>
                        <WidgetUrlSite sign='URL' active={openUrl} onClick={() => setOpenUrl(v => !v)} />
                        {openUrl && <UrlSiteManager />}
                    </div>
                </div>
            </CenterLayout>
        </MainLayout>
    );
};

export default Parametre;
